import React from 'react';
import ProgressBar from '../../ProgressBar/containers/ProgressBar';
import logoSvg from '../../../assets/Header/Logo Group.svg';
import logoPng from '../../../assets/Header/Logo Group.png';
import horizonLogo from '../../../assets/Header/horizon_logo.png';
import { ReactComponent as PhoneIcon } from '../../../assets/Header/call.svg';
import { ReactComponent as HorizonPhoneIcon } from '../../../assets/Header/horizon_call.svg';
import PropTypes from 'prop-types';
import './Header.css';
import queryString from 'query-string';
import { isMacOS } from './../../../utils/isMacOS'
import { isFirefox } from './../../../utils/isFirefox'
import { isHorizon } from '../../../utils/brandHelper';
class Header extends React.Component {
  state = {
    phone: "800-644-2926",
    mobileViewPhone: "800 644 2926"
  };

  componentDidUpdate() {
    this.refs.top.scrollIntoView(true);
  }

  componentDidMount() {
    const params = queryString.parse(window.location.search);
    if(params["phone"])
      sessionStorage.setItem('phone', params["phone"]);

    if(isHorizon) {
      this.setState({phone: "800-862-4020", mobileViewPhone: "800 862 4020"});
    } else if(sessionStorage.getItem("phone")) {
      this.setState({phone: sessionStorage.getItem("phone"), mobileViewPhone: sessionStorage.getItem("phone")})
    }
  }

  render() {
    const logo = isHorizon ? horizonLogo : (!isMacOS() && isFirefox() ? logoPng : logoSvg);
    const url = isHorizon ? "https://horizonseniorbenefits.com/" : "https://choicemutual.com"

    return (
      <header ref="top" className={"d-flex align-items-center content"}>
        <div className={`col-md-3 d-md-flex h-auto px-0`}>
          <figure className="logo mb-0 py-2">
            {this.props.logoLink ?
            <a href={url} target="_parent" rel="noopener noreferrer">
              <img src={logo} alt="Company Logo" />
            </a> 
            : 
            <img src={logo} alt="Company Logo" />}
          </figure>
        </div>
        {<div className="col-md-6 d-none d-md-flex mdProggressBarContainer">
          {this.props.progressBar && <ProgressBar />}
        </div>}

        {isHorizon ? 
          <div className="col-6 col-md-3 px-0 d-flex justify-content-end">
            <div className="">
              <div class="quote-help">
                  <a href="tel:800-862-4020" class="phone-icon"><i class="quote-icon-phone"></i></a>
                  <div class="phone-content d-none d-sm-block">
                      <span>NEED FREE ADVICE?</span>
                      <p><a href="tel:800-862-4020">(800) 862 - 4020</a></p>
                  </div>
              </div>
            </div>
          </div>
        :
          <div className="col-6 col-md-3 px-0 d-flex justify-content-end">
            <div className="row contact text-center mx-0 text-sm-right">
              <div className="col-12 px-0">
                <span className='d-block'>Speak to a licensed agent:</span>
              </div>
              <div className="col-12 d-flex text-center phoneWrapper px-0 justify-content-center align-items-center">
                <a className="d-flex" href={`tel:${this.state.phone}`}>
                <span className="svg-phone me-2">{isHorizon ? <HorizonPhoneIcon />  : <PhoneIcon className="" />}</span>
                {this.state.phone}
                </a>
              </div>
            </div>
          </div>}
      </header>
    );
  }
}

Header.propTypes = {
  mode: PropTypes.string
};

export default Header;
